module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAOCAYAAAArMezNAAAAAXNSR0IArs4c6QAAADhJREFUOBFj/P///yUGBgZdIKYmuMwINDgSaKI6NU0FmnWTyuaNGoclBECRN5oqsATMiBYaeqkCAOx0G3bu7BZWAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./resources/images/menu_1x.png
// module id = 2307
// module chunks = 0